import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Image, Text } from '@user-portal/wikr-components';

import Modal from 'components/Modal';
import ContactUsLink from 'components/ContactUsLink';

import attention from 'assets/img/webp/attention.webp';

import { ErrorModalProps } from './types';

const ErrorModal = ({ onClose, onSubmit }: ErrorModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal paddingX={16} paddingY={16} buttonWithBackground isOpen onClose={onClose} withCloseButton>
            <Box $paddingTop={56} $paddingBottom={12}>
                <Image src={attention} alt="attention" center maxWidth={48} mb={12} />
                <Text type="h5" center mb={24}>
                    {t('basics.somethingWentWrong')}
                </Text>
                <Button onClick={onSubmit} mb={20}>
                    {t('basics.tryAgain')}
                </Button>
                <ContactUsLink boldText />
            </Box>
        </Modal>
    );
};

export default ErrorModal;
